import { render, staticRenderFns } from "./ClassCart.vue?vue&type=template&id=19422076&scoped=true&"
import script from "./ClassCart.vue?vue&type=script&lang=js&"
export * from "./ClassCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19422076",
  null
  
)

export default component.exports